<div>
  <div class="col-md-12">
    <div class="col-7 pl-0">
      <div class="input-group">
        <mat-form-field appearance="outline">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="start"   [(ngModel)]="start">
            <input matEndDate  placeholder="kraj" [(ngModel)]="end">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
    <div class="row align-items-end">
      <div class="col-5 text-right">
        <button [disabled]="disableDateRangeButton"
          style="border-radius: 35px;background: #55c579;
                 border-color: #55c579;font-size: 12px; min-width: 100px; margin-top: 10px" class="btn btn-primary ml-2 btn-sm" type="button;"
          (click)="getActivitiesDataRange()">
          <i class="fa fa-download" aria-hidden="true"></i>
          Preuzmi
        </button>
      </div>
    </div>

  </div>

</div>


<div class="full-width">
    <div class="col-7 pl-0">
        <div class="input-group">
            <button class="btn btn-outline-secondary calendar scac-calendar" (click)="datepicker.toggle()"
                    type="button">
                <span><i class="fa fa-calendar"></i></span>
            </button>
            <input class="form-control no-border white-background"
                   placeholder="Izaberite datum"
                   (click)="datepicker.toggle()"
                   [(ngModel)]="date"
                   readonly
                   dateFormat="dd-MMM-yyyy"
                   ngbDatepicker
                   #datepicker="ngbDatepicker">
        </div>
    </div>

    <div class="col-5 text-right">
        <button [disabled]="disableButton == true"
                style="    border-radius: 35px;background: #55c579;
                 border-color: #55c579;font-size: 12px;" class="btn btn-primary ml-2 btn-sm" type="button"
                (click)="sendActivitiesToProventum()">
            <i class="fa fa-paper-plane" aria-hidden="true"></i>
            Pošalji
        </button>
    </div>

</div>
<div>
    <app-new-activity-modal (outputActivitiesToParent)="getActivitiesFromChildHandler($event)"
                            [date]="date">

    </app-new-activity-modal>
</div>
